module.exports = __webpack_public_path__ + "img/rent.8ae54dd8.svg";